import { NavLink } from 'react-router-dom';
import { Common } from '@thecvlb/design-system';
import classNames from 'classnames';

import { PathName } from 'utils/enums';

import { getMinutesToMessage, getStartTimeToMinutesDiff } from './appointmentTimerBanner.settings';
import { AppointmentTimerBannerProps } from './appointmentTimerBanner.types';

const AppointmentTimerBanner: React.FC<AppointmentTimerBannerProps> = ({
  displayWaitTime,
  startTime,
  canJoin = false,
  category = '',
  appointmentID = '',
  hasStaffJoined = false
}) => {
  return (
    <NavLink
      className={classNames(
        'flex h-12 w-full flex-wrap items-center justify-center text-mBase font-bold md:text-base',
        hasStaffJoined ? 'bg-green-600 text-white' : 'bg-primary-200 text-primary-700',
        {
          'cursor-default': !canJoin
        }
      )}
      to={
        category === 'queue'
          ? `${PathName.Appointment}/${appointmentID}`
          : `${PathName.ZoomCall}?callId=${appointmentID}`
      }
      onClick={(e) => !canJoin && e.preventDefault()}
    >
      <Common.Icon className="mr-1 size-6" name="clock" />
      {hasStaffJoined ? (
        <span>Your provider is ready</span>
      ) : (
        <>
          <span className="font-medium">Time to call:&nbsp;</span>
          <b data-testid="time_to_call">
            {displayWaitTime || getMinutesToMessage(getStartTimeToMinutesDiff(startTime))}
          </b>
        </>
      )}
    </NavLink>
  );
};

export default AppointmentTimerBanner;
